import request from 'utils/request';

import { removeWhitespace } from 'utils/stringMutation';
import { getValuationState } from '../ProviderWithRouter';

export const getActiveCampaignData = async (make, model) => {
  try {
    const axiosRequest = await request();
    const resp = await axiosRequest({
      method: 'GET',
      url: '/campaign-active',
      params: { make, model }
    });

    if (resp && resp.status !== 200) {
      return null;
    }

    return resp.data;
  } catch (e) {
    console.warn(e);
  }
};

export const sendToDriftrock = async oemCampaignData => {
  const valuationState = getValuationState();

  const enquiryType = oemCampaignData
    ? oemCampaignData && oemCampaignData.enquiryType
    : '';

  const make = oemCampaignData
    ? valuationState.formValues.desiredMake
    : valuationState.carDetails.manufacturer;

  const model = oemCampaignData
    ? valuationState.formValues.desiredModel
    : valuationState.carDetails.model;

  const data = {
    salutation: valuationState.formValues.salutation,
    firstName: removeWhitespace(valuationState.formValues.firstName),
    lastName: removeWhitespace(valuationState.formValues.lastName),
    phone: removeWhitespace(valuationState.formValues.phone),
    email: removeWhitespace(valuationState.formValues.email),
    postcode: removeWhitespace(valuationState.formValues.postcode),
    marketingPermission: valuationState.formValues.marketingPermission,
    make,
    model,
    zutoOptIn: !!valuationState.formValues.zutoOptIn,
    campaignOptIn: !!valuationState.formValues.campaignOptIn,
    vitalityOptIn: !!valuationState.formValues.vitalityOptIn,
    enquiryPlatformSource: 'Valuations',
    enquiryType
  };
  try {
    const url = '/driftrock';
    const axiosRequest = await request();
    await axiosRequest.post(url, data);
  } catch (e) {
    console.log('Error while sending data to Driftrock', e);
  }
};



// WEBPACK FOOTER //
// ./src/utils/campaignsAndDriftrock.js